import { Socket } from 'socket.io-client';
import { notUndefined } from '../util/Assert';
import { PushNotification } from '../domain/notification/NotificationDomains';
import NavigationUtil from '../util/NavigationUtil';

class NotificationService {
  private readonly socket: Socket;

  constructor(socket: Socket) {
    notUndefined(socket, 'Socket cannot be undefined');
    this.socket = socket;
  }

  public listen(): VoidFunction {
    const channelName = `notification-${NavigationUtil.getTenant()}`;
    this.socket.on(channelName, this.onNotification);
    return () => {
      this.socket.off(channelName, this.onNotification);
    };
  }

  private onNotification(notification: PushNotification) {
    const icon = document.getElementById('notification-icon');
    if (icon) {
      icon.classList.add('notification-icon');
    }
    setTimeout(() => {
      icon?.classList.remove('notification-icon');
    }, 5000);
  }
}

export default NotificationService;
